import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, IconButton, MenuItem, Paper, Select, Tooltip } from '@material-ui/core';
// import { useTheme } from '@emotion/react';
import {ImportExport, PlaylistAddCheck, Search } from '@material-ui/icons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { es } from 'date-fns/locale'
import "react-datepicker/dist/react-datepicker.css";
import { DataGrid } from '@mui/x-data-grid';
// import { esES } from '@mui/x-data-grid/locales';
import CircularProgressWithLabel from '../../components/Complements/CircularProgressWithLabel';

// import { useTheme } from '@material-ui/core';

const CheckPayrollComponent = props => {
  const { handleFindActivity, setStartDate, setEndDate, startDate,
    endDate, accountList = [], dataJson = [],
    getValidators, getTransactions, processPercent = 0 } = props;
  const [selectedAccount, setSelectedAccount] = useState(
    accountList[0] || ''
  );
  // const theme = useTheme();
  // const maxDate = moment().add(7, 'days').toDate();


  // const onChange = (dates) => {
  //   console.log(dates);
  //   const [start, end] = dates;
  //   setStartDate(start);
  //   setEndDate(end);
  // };

  const columns = [
    {
      field: 'account',
      headerName: 'Cuenta origen',
      flex: 1,
      sortable: false,
    },
    {
      field: 'concept',
      headerName: 'Concepto',
      flex: 1,
      sortable: false,
    },
    {
      field: 'value',
      headerName: 'Valor',
      flex: 1,
      sortable: false,
      valueGetter: (params) => `$ ${parseFloat(params.row.value).toFixed(2)}`,
    },
    {
      field: 'totalTransaction',
      headerName: 'Total Transferido',
      flex: 1,
      sortable: false,
      valueGetter: (params) => `$ ${parseFloat(params.row.totalTransaction).toFixed(2)}`,
    },
    {
      field: 'name',
      headerName: 'Estado',
      flex: 1,
      renderCell: (params) => {
        const color = params.row.color; // Obtén el valor de 'state' desde los datos
        return (
          <Box display='flex' flex={1} flexWrap='wrap' flexDirection='column'>
            {
              params.value === 'EN PROCESO' ?
                <Box style={{ paddingLeft: '20%' }}>
                  <CircularProgressWithLabel value={processPercent} />
                  {/* <Typography style={{ fontSize: 10 }}>{'En progreso'}</Typography> */}
                </Box> :
                <span style={{ color, fontWeight: 'bold' }}>
                  {params.value}
                </span>
            }
          </Box>
        );
      },
      sortable: false,
    },
    {
      field: 'createdAt',
      headerName: 'Fecha',
      renderCell: (params) => {
        return (
          <span style={{}}>
            {moment(params.value).format('DD/MM/YYYY hh:mm:ss')}
          </span>
        );
      },
      flex: 1,
      sortable: false,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: ' ',
      flex: 1,
      renderCell: (params) => {
        return <Grid>
          {/* <Button color='approve' variant='outlined' style={{ marginRight: 4 }} onClick={() => getValidators(params.row)}>
            Validadores
          </Button> */}
          <Tooltip arrow title={"Validadores"}>
            <IconButton onClick={() => getValidators(params.row)}>
              <PlaylistAddCheck />
            </IconButton>
          </Tooltip>
          {(params.row.name === 'VERIFICADO') &&
            <Tooltip arrow title={"Transferencias"}>
              <IconButton onClick={() => getTransactions(params.row)}>
                <ImportExport style={{ transform: 'rotate(90deg)' }} />
              </IconButton>
            </Tooltip>
          }
        </Grid>

      },

    },
  ];

  useEffect(() => {
    if (accountList && accountList[0]) {
      setSelectedAccount(accountList[0]);
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (event) => {
    setSelectedAccount(event.target.value);
  };

  const renderData = () => (
    <Box style={{ width: '100%' }}>

        <DataGrid
          autoHeight
          // className='table-style'
          columns={columns}
          // disableColumnSelector
          // pagination
          // // localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          isRowSelectable={() => false}
          rows={dataJson}
          localeText={{
            columnsPanelShowAllButton: 'Show all', // ocultamos el texto "Show all"
            columnsPanelHideAllButton: '', // ocultamos el texto "Hide all"
          }}
          // getRowHeight={() => 'auto'}
          // keepNonExistentRowsSelected
          // getRowId={(row) => row.id}
          // initialState={{
          //   pagination: { paginationModel: { pageSize: 5 } },
          // }}
          // pageSizeOptions={[5, 10, 25, { value: -1, label: 'All' }]}
          // style={{ background: '#fff' }}
        />

    </Box>
  );
  const renderBody = () => (
    <Paper elevation={0} style={{ display: 'flex', flexDirection: 'column', gap: 8, margin: 16, borderRadius: 16, padding: 16 }}>
      <Box display='flex' flex={1} flexWrap='wrap' flexDirection='column' gridGap={8} component={'div'}>
        <h2>Detalle de pago de nómina.</h2>
        <Box display='flex' flex={1} flexWrap='wrap' borderRadius='20px' padding={1.5} >
          <Grid xs={12} md={12} lg={4} alignContent='center' >
            <Select
              fullWidth
              label='Cuentas'
              labelId='demo-simple-select-label'
              id='entity'
              value={selectedAccount}
              onChange={handleChange}
            >
              {accountList.map((option) => {
                return (
                  <MenuItem
                    key={`${option.prodCodigo}_account`}
                    value={option}
                  >{`${option.PRODUCTBANKID || ''} - ${option.PRODUCTALIAS || ''
                    }`}</MenuItem>
                );
              })}
            </Select>
          </Grid>
          <Grid xs={12} md={12} lg={8} container style={{ padding: '10px'}}>
            <Grid
              item
              xs={12} md={12} lg={8}
              style={{ display: 'flex', justifyContent: 'space-evenly' }}
            >
              <div style={{ flex: 0 }}>
                <label>Desde</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  locale={es}
                  title='Desde'
                />
              </div>
              <div style={{ flex: 0 }}>
                <label>Hasta</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  locale={es}
                  title='Hasta'
                />
              </div>
            </Grid>
            <Grid xs={12} md={12} lg={4} style={{ textAlign: 'center', alignContent: 'center' }}>
              <Button color='secondary' variant='contained'
                endIcon={<Search />}
                disabled={startDate === null || endDate === null}
                onClick={() => handleFindActivity(selectedAccount.PRODUCTBANKID)}>
                Buscar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box style={{ paddingTop: 1 }}>
        {renderData()}
      </Box>
    </Paper>
  );
  return (
    <>
      {renderBody()}
    </>
  );
};

CheckPayrollComponent.propTypes = {

};

export default CheckPayrollComponent;
